import { createApp } from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';;

import JsonExcel from "vue-json-excel3";
import Vue3DraggableResizable from 'vue3-draggable-resizable';
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css';
import { createPinia } from 'pinia';
import "quasar/dist/quasar.sass";
import quasarUserOptions from './quasar-user-options';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import ganttastic from '@infectoone/vue-ganttastic'
import dayjs from 'dayjs'
import 'dayjs/locale/es'


import App from './App.vue';
import router from './router';

import ExportModalComponent from '@/ui/components/modals/export/ExportModalComponent.vue';
import ConfirmModalComponent from "@/ui/components/modals/ConfirmModalComponent.vue";
import InformativeModalComponent from '@/ui/components/modals/InformativeModalComponent.vue';
import TableComponent from '@/ui/components/tables/TableComponent.vue';
import SelectComponent from '@/ui/components/selects/SelectComponent.vue';
import ActiveDropdownComponent from '@/ui/components/dropdowns/active-dropdown/ActiveDropdownComponent.vue';
import FilterListComponent from '@/ui/components/filters/FilterListComponent.vue';
import FilterButtonComponent from '@/ui/components/filters/FilterButtonComponent.vue';
import SubservicesHeader from '@/ui/components/subservices-header/SubservicesHeader.vue';
import FilterSelectComponent from '@/ui/components/filters/FilterSelectComponent.vue';
import CompanyAutocompleteComponent from '@/ui/components/autocompletes/fleet-management/CompanyAutocompleteComponent.vue';
import HistoricModalComponent from '@/ui/components/modals/historic/HistoricModalComponent.vue';
import MapComponent from './ui/components/maps/map-component/MapComponent.vue';

import LineComponent from '@/ui/components/graphs/line/LineComponent.vue';
import BarComponent from '@/ui/components/graphs/bar/BarComponent.vue';
import RichTextComponent from './ui/components/richtext/RichTextComponent.vue';
import PieComponent from './ui/components/graphs/pie/PieComponent.vue';


dayjs.locale('es')

const app = createApp(App)
    .use(Quasar, quasarUserOptions)
    .use(router)
    .use(Vue3DraggableResizable)
    .use(createPinia())
    .use(VueTelInput)
    .use(ganttastic)
    .component('export-excel-csv', JsonExcel)
    .component('export-data-modal', ExportModalComponent)
    .component('confirm-modal', ConfirmModalComponent)
    .component('informative-modal', InformativeModalComponent)
    .component('historic-modal', HistoricModalComponent)
    .component('table-component', TableComponent)
    .component('map-component', MapComponent)
    .component('select-component', SelectComponent)
    .component('active-dropdown-component', ActiveDropdownComponent)
    .component('filter-list-component', FilterListComponent)
    .component('company-autocomplete-component', CompanyAutocompleteComponent)
    .component('filter-select-component', FilterSelectComponent)
    .component('filter-button-component', FilterButtonComponent)
    .component('subservice-header-component', SubservicesHeader)
    .component('line-component', LineComponent)
    .component('bar-component', BarComponent)
    .component('pie-component', PieComponent)
    .component('rich-text-component', RichTextComponent);

app.config.errorHandler = (err, instance, info) => {
    console.error('Global Error Handler:', err, info);
};

app.mount('#app');
